import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 75px 0;
  @media (max-width: 600px) {
    margin: 50px 0;
  }
`;

export const Box = styled.div`
  width: calc(100% - 40px);
  max-width: 1180px;
  margin: 0 auto;
  iframe {
    box-sizing: border-box;
    padding: 10px;
    background-image: linear-gradient(
      89.91deg,
      #6530cf 0.64%,
      #1032f2 23.92%,
      #83e460 43.07%,
      #efe755 61.69%,
      #df7c36 80.84%,
      #d24237 99.98%
    );
  }
`;

export const Thumbs = styled.div`
  min-width: 100%;
  display: flex;
  overflow-x: auto;
  margin-top: 60px;
  -webkit-overflow-scrolling: touch;
  @media (max-width: 600px) {
    margin-top: 30px;
  }
`;

export const Slider = styled.div`
  display: flex;
  position: relative;
  transition: all 220ms ease-in-out;
  ${({ scrollIndex }) =>
    scrollIndex &&
    css`
      transform: translateX(calc(${scrollIndex} * 215 * 1px));
    `};
`;

export const Arrow = styled.button`
  position: absolute;
  left: 0;
  z-index: 10;
  color: #0000ff;
  background: transparent;
  width: 40px;
  outline: none;
  border: 0;
  height: 120px;
  font-size: 2em;

  @media (max-width: 700px) {
    display: none;
  }

  ${({ right }) =>
    right &&
    css`
      left: auto;
      right: 0;
    `};
`;

export const Thumbnail = styled.img`
  width: 200px;
  margin-right: 15px;
  box-sizing: border-box;
  border: 8px solid;
  border-image: linear-gradient(
    89.91deg,
    #6530cf 0.64%,
    #1032f2 23.92%,
    #83e460 43.07%,
    #efe755 61.69%,
    #df7c36 80.84%,
    #d24237 99.98%
  );
  transition: all 180ms ease-out;
  ${({ active }) =>
    active &&
    css`
      border-color: #0000ff;
    `} &:hover {
    border-color: #0000ff;
  }

  @media (max-width: 600px) {
    width: 150px;
  }
`;

export const ThumbCont = styled.div`
  box-sizing: border-box;
  margin-left: 10px;
  transition: all 180ms ease-out;
  cursor: pointer;
`;

export const Title = styled.div`
  text-transform: uppercase;
  font-size: 2em;
  padding: 80px 0 0;
  text-align: center;
  font-family: 'GT America';
  font-weight: bold;
  font-style: italic;
`;
